(function() {
    'use strict';

    angular
        .module('masterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('final-summary', {
            url: '/final-summary',
            data: {
                pageTitle: 'Khóa sổ bằng tay'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=master/final-summary/final-summary',
                    controller: 'FinalSummaryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('final-summary.confirm', {
            url: '/confirm',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: GLOBAL_URL+'partial?uri=master/final-summary/final-summary-confirm-dialog',
                    controller: 'FinalSummaryConfirmController',
                    controllerAs: 'vm',
                    size: 'md'
                }).result.then(function() {
                    $state.go('final-summary', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
